import React, { useMemo } from 'react';
import {
  Button,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import SearchIcon from '@mui/icons-material/Search';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';
import { GRUPOS } from '../model/pacienteConstants';
import { usePacientesTable } from '../hooks/usePacientesTable';
import ExcludePacienteButton from './ExcludePacienteButton';

export default function PacientesTable() {
  const navigate = useNavigate();
  const {
    loading,
    filteredPatients,
    searchName,
    setSearchName,
    searchId,
    setSearchId,
    filterGroup,
    setFilterGroup,
    filterSexo,
    setFilterSexo,
    resetFilters,
    fetchPatients,
    removePaciente,
  } = usePacientesTable();

  const columns = useMemo(() => [
    { field: 'id', headerName: 'ID', width: 100 },
    { field: 'nombre', headerName: 'Nombre y Apellidos', width: 200, flex: 1 },
    { field: 'dateBirth', headerName: 'Fecha de Nacimiento', width: 150 },
    { field: 'grupoNombre', headerName: 'Grupo', width: 180 },
    { field: 'sexo', headerName: 'Sexo', width: 120 },
    {
      field: 'actions',
      headerName: 'Acciones',
      width: 150,
      sortable: false,
      renderCell: (params) => (
        <>
          <IconButton
            onClick={(event) => {
              event.stopPropagation();
              navigate(`/editar-paciente/${params.row.id}`);
            }}
          >
            <EditIcon />
          </IconButton>
          <ExcludePacienteButton pacienteId={params.row.id} onDeleted={removePaciente} />
        </>
      ),
    },
  ], [navigate, removePaciente]);

  return (
    <>
      <Typography variant="h6" gutterBottom color="#0D6AEE">
        Lista de Pacientes
      </Typography>

      <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }} wrap="wrap">
        <Grid item xs>
          <TextField
            size="small"
            fullWidth
            label="Buscar por nombre"
            value={searchName}
            onChange={(e) => setSearchName(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs>
          <TextField
            size="small"
            fullWidth
            label="Buscar por ID"
            value={searchId}
            onChange={(e) => setSearchId(e.target.value)}
            type="number"
          />
        </Grid>
        <Grid item xs>
          <Select size="small" fullWidth value={filterGroup} onChange={(e) => setFilterGroup(e.target.value)} displayEmpty>
            <MenuItem value="">Todos los grupos</MenuItem>
            {Object.keys(GRUPOS).sort((a, b) => a - b).map((key) => (
              <MenuItem key={key} value={key}>{GRUPOS[key]}</MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs>
          <Select size="small" fullWidth value={filterSexo} onChange={(e) => setFilterSexo(e.target.value)} displayEmpty>
            <MenuItem value="">Todos los sexos</MenuItem>
            <MenuItem value="Hombre">Hombre</MenuItem>
            <MenuItem value="Mujer">Mujer</MenuItem>
          </Select>
        </Grid>
      <Grid item xs>
          <Button fullWidth variant="contained" onClick={fetchPatients} startIcon={<RestartAltIcon />}>
            Refrescar
          </Button>
        </Grid>
        <Grid item xs>
          <Button fullWidth variant="contained" color="secondary" onClick={resetFilters} startIcon={<RestartAltIcon />}>
            Resetear
          </Button>
        </Grid>
        <Grid item xs>
          <Button fullWidth variant="contained" color="primary" onClick={() => navigate('/crear-paciente-user')} startIcon={<PersonAddIcon />}>
            Crear Paciente
          </Button>
        </Grid>
      </Grid>

      <DataGrid
        loading={loading}
        rows={filteredPatients}
        columns={columns}
        pageSize={25}
        rowsPerPageOptions={[5, 10, 25]}
        disableSelectionOnClick
        onRowClick={(params) => navigate(`/paciente/${params.row.id}`)}
        slots={{ toolbar: GridToolbar }}
      />
    </>
  );
}
